import React, { Component } from 'react';
import {Form, Control, Fieldset, Errors } from 'react-redux-form';
import { isRequired } from "../field_validations";
import _ from 'lodash';
import {confirmAlert} from "react-confirm-alert";

class ConceptFormEdit extends Component {
	render(){
		const { concepts } = this.props;

		return(
			<div className="columns is-centered">
				<div className="column is-10">
					{/*this.state.modalShow ? <UnitModal active={this.state.modalShow} />:''*/}
					<Form model="concepts.edit" onSubmit={(values) => this._handleSubmit(values)} onSubmitFailed={(error) => {this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger'); console.log('error', error)}}>
						<fieldset className="fieldset">
							<div className="field is-grouped">
								<div className="control is-expanded">
									<label htmlFor="name" className="label">Nombre del concepto de gasto <span className="small has-text-danger">*</span></label>
									<Control.text model=".name" id="name" className="input" placeholder="Nombre" errors={{isRequired}} validateOn="change"/>
									<Errors model=".name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El nombre es obligatorio'}} />
								</div>
								{/*<div className="control">
									<label htmlFor="status" className="label">Estatus <span className="small has-text-danger">*</span></label>
									<div className="select">
										<Control.select model=".status_id" id="status" className="select" errors={{required}} validateOn="change">
											<option value="">--- Estatus ---</option>
											{status.data.map((stat, k) => {
												return <option value={stat.id} key={k}>{stat.name}</option>
											})}
										</Control.select>
									</div>
									<Errors model=".status_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
								</div>*/}
							</div>
						</fieldset>

						<fieldset className="fieldset">
							<legend>Añadir Unidad</legend>
							<div className="field is-grouped">
								<div className="control is-expanded">
									<label htmlFor="unit_name" className="label">Nombre de la unidad <span className="small has-text-danger">*</span></label>
									<Control.text model=".unit_name" id="unit_name" className="input"  />
									{concepts.edit.unit_name ?
										'':<small className="help has-text-danger">El nombre es obligatorio</small>}
								</div>

								{/*<div className="control">
									<label htmlFor="unit_status" className="label">Estatus <span className="small has-text-danger">*</span></label>
									<div className="select">
										<Control.select model=".unit_status" id="unit_status" className="select" value={concepts.edit.unit_status ? concepts.edit.unit_status:''}>
											<option value="">--- Estatus ---</option>
											{status.data.map((stat, k) => {
												return <option value={stat.id} key={k}>{stat.name}</option>
											})}
										</Control.select>
									</div>
									{concepts.edit.unit_status ?
										'':<small className="help has-text-danger">El estatus es obligatorio</small>}
								</div>*/}
							</div>

							<div className="field is-grouped">
								<div className="control">
									<div className="message is-primary">
										<div className="message-body">
											<div className="field">
												<div className="control">
													<label htmlFor="unit_invoiceable" className="checkbox">
														<Control.checkbox model=".unit_invoiceable" id="unit_invoiceable" className="checkbox" isToggle={true} />
														<span style={{whiteSpace:'normal'}}> Facturable </span>
													</label>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button type="button" className="button is-primary" onClick={() => this._unitAdd()}>Agregar Unidad</button>
								</div>
							</div>
						</fieldset>

						{!_.isEmpty(concepts.edit.units) ?
							<div className="columns">
								<div className="column">
									<p className="title is-6">Listado de Unidades del Concepto</p>

									<table className="table is-fullwidth project-goal-table">
										<thead>
										<tr>
											<th>#</th>
											<th>Unidad</th>
											<th>Facturable</th>
											{/*<th>Estatus</th>*/}
											<th>Acciones</th>
										</tr>
										</thead>
										<Fieldset model='.units' component='tbody' >
											{_.map(concepts.edit.units, (row, k) => {
												return (
													<tr key={k}>
														<td className="goal-cell" style={{width:'10%'}}>
															<strong>{k+1}</strong>
														</td>
														<td >{row.name}</td>
														{this.state.unitEdit && this.state.unitIndex === k ?
															<td>
																<div className="control">
																	<label htmlFor={`[${k}].invoiceable`} className="label">
																		<Control.checkbox model={`[${k}].invoiceable`} id={`[${k}].invoiceable`} isToggle={true}/>
																		Facturable
																	</label>
																</div>
															</td>
															:<td ><span>{(row.invoiceable ? 'Facturable':'')}</span></td>}
														{/*this.state.unitEdit && this.state.unitIndex === k ?
															<td>
																<div className="control">
																	<div className="select">
																		<Control.select model={`[${k}].status_id`} id={`[${k}].status_id`} className="select">
																			<option value="">--- Estatus ---</option>
																			{status.data.map((stat, k) => {
																				return <option value={stat.id} key={k}>{stat.name}</option>
																			})}
																		</Control.select>
																	</div>
																	<Errors model={`[${k}].status_id`} show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
																</div>
															</td>
															:<td ><span>{(row.status_id===1 || row.status_id==='1' ? 'Activo':'Inactivo')}</span></td>*/}
														<td style={{width:'10%'}}>
															<div className="field is-grouped">
																<div className="control">
																	{this.state.unitEdit && this.state.unitIndex === k ?
																		<button type="button" onClick={() => this._closeEdit()} className="button is-warning"><i className="fa fa-times" /></button>
																		:<button type="button" className="button is-info" onClick={() => this._editUnit(k)}><i className="fa fa-edit" /></button>}
																</div>
																<div className="control">
																	{this.state.unitEdit && this.state.unitIndex === k ?
																		''
																		:<button type="button" onClick={() => this._getConfirm(k,row.name)} className="button is-danger"><i className="fa fa-trash" /></button>}
																</div>
															</div>
														</td>
													</tr>
												)
											})}
										</Fieldset>
									</table>
								</div>
							</div>
							:''}

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" className="button is-large" onClick={() => this.props.history.push('/gastos/conceptos')}>
									Regresar
								</button>
							</div>
							<div className="control">
								<Control.button model="concepts.edit" className="button is-primary is-large" type="submit" disabled={this._validateSave()}>
									Guardar
								</Control.button>
							</div>
						</div>

						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
					</Form>
				</div>
			</div>
		);
	}

	constructor() {
		super();
		this.state = {
			modalShow: false,
			unitEdit: false,
			unitIndex: undefined
		}
	}

	_handleSubmit(values) {
		this.props.conceptSave(values);
	}

	_unitAdd(){
		let { concepts } = this.props;
		if(!_.isEmpty(concepts.edit.unit_name) /*&& !_.isEmpty(concepts.edit.unit_status)*/){
			this.props.add('concepts.edit.units',{
				name: concepts.edit.unit_name,
				/*status_id: concepts.edit.unit_status,*/
				invoiceable: concepts.edit.unit_invoiceable
			})

			this.props.change('concepts.edit.unit_name', undefined);
			/*this.props.change('concepts.edit.unit_status', undefined);*/
			this.props.change('concepts.edit.unit_invoiceable', undefined);
		}
	}

	_editUnit(index) {
		this.setState({
			unitEdit: true,
			unitIndex: index
		})
	}

	_closeEdit() {
		this.setState({
			unitEdit: false,
			unitIndex: undefined
		})
	}

	_getConfirm(index, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar la unidad "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this._removeUnit(index)
		})
	}

	_removeUnit(index) {
		this.props.remove('concepts.edit.units', index);
	}

	_validateSave(){
		const {concepts} = this.props;
		let cc = _.find(concepts.permissions, (o) => {return o==='Create'});
		let cu = _.find(concepts.permissions, (o) => {return o==='Update'});

		if(!_.isEmpty(concepts.edit) && concepts.edit.id){
			if(cu){
				return false;
			}else {
				return true;
			}
		}else if(!_.isEmpty(concepts.edit) && _.isEmpty(concepts.edit.id)){
			if(cc){
				return false;
			}else {
				return true;
			}
		}else {
			return true;
		}
	}
}

export default ConceptFormEdit;


// WEBPACK FOOTER //
// ./src/elements/concepts/form.jsx